import { api } from './api';

export async function getAchievements(filters?: any[], limit = 100) {
  let payload: any[] = [];

  if (filters) {
    payload.concat(filters);
  }

  payload.push({
    $sort: {
      time: -1,
    },
  });

  if (limit) {
    payload.push({
      $limit: limit,
    });
  }

  const { data } = await api.post(`database/achievement/aggregate`, payload);
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data;
  }
}

export async function getPointsHistory(player?: string, start?: any, end?: any) {
  try {
    const payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };
    const { data } = await api.post('find/extrato_pontos', payload, { headers: { Range: 'items=0-1000' } });
    // console.log('getKPIHistorico', data);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getPointsSummary(player?: string, start?: any, end?: any) {
  try {
    const payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };
    const { data } = await api.post('find/extrato_resumo', payload, { headers: { Range: 'items=0-1000' } });
    // console.log('getKPIHistorico', data);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data[0];
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getReconhecimentos(player?: string, start?: any, end?: any) {
  try {
    const payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };
    const { data } = await api.post('find/resultado_reconhecimento', payload, { headers: { Range: 'items=0-1000' } });
    // console.log('getKPIHistorico', data);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getDestaqueCultura(player?: string, start?: any, end?: any) {
  try {
    const payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };
    const { data } = await api.post('find/resultado_cultura', payload, { headers: { Range: 'items=0-1000' } });
    // console.log('getKPIHistorico', data);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    // console.log('ERROR: getKPIHistorico ', e);
    throw e;
  }
}

export async function getMissaoGestor(player?: string, start?: any, end?: any) {
  try {
    const payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };

    const { data } = await api.post('find/extrato_missao_gestor', payload, { headers: { Range: 'items=0-1000' } });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function getMissaoEquipe(player?: string, start?: any, end?: any) {
  try {
    const payload = {
      player,
      start: start ? start : new Date(2023, 0, 1),
      end: end ? end : new Date(),
    };

    const { data } = await api.post('find/extrato_missao_equipe', payload, { headers: { Range: 'items=0-1000' } });

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}

export async function updateAchievement(data?: any[]) {
  try {
    const response = await api.put('/database/achievement?strict=true', data);
    if (!response.data) {
      throw new Error('Erro ao salvar achievement');
    } else {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function getTeamStatus(unidade: string) {
  let payload: any[] = [];

  if (unidade) {
    payload.push(
      {$match:{ "player": unidade }},
      {$group:{ _id: "$item", total:{$sum: "$total"}}}
    );
  }

  const { data } = await api.post(`database/achievement/aggregate?strict=true`, payload);
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data;
  }
}

/**
 * Quantos cards de cada item o player já teve, considerando tanto os ganhos
 * quanto os consumos — o maior dos dois, porque o crédito de cards instantâneos
 * nem sempre é registrado. Diferente do saldo em catalog_items, esse total não
 * é reduzido quando o card é usado, então serve de histórico do que ele já
 * conquistou.
 */
export async function getCardsRecebidos(player: string) {
  const payload = [
    { $match: { player, type: 2 } },
    {
      $group: {
        _id: '$item',
        ganhos: { $sum: { $cond: [{ $gt: ['$total', 0] }, '$total', 0] } },
        consumos: { $sum: { $cond: [{ $lt: ['$total', 0] }, { $abs: '$total' }, 0] } },
      },
    },
    { $project: { total: { $max: ['$ganhos', '$consumos'] } } },
  ];

  const { data } = await api.post(`database/achievement/aggregate?strict=true`, payload);
  if (!Array.isArray(data)) {
    return {};
  }

  return data.reduce((acc: { [key: string]: number }, o: any) => {
    acc[o._id] = o.total;
    return acc;
  }, {});
}

export async function getNovasEntregas(userId?: string) {
  let payload: any[] = [];

  payload.push(    
    {$match:{ "player": userId, "extra.status": "ENV" }},
    {$group:{"_id": null, "total": {$sum: 1}}}
  );

  const { data } = await api.post(`database/deliveries__c/aggregate?strict=true`, payload);
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data;
  }
}

export async function getEntregas(userId?: string) {
  let payload: any[] = [];

  payload.push(
    {$match:{ "player": userId }},
    {$sort: { time: -1 }}
  );

  const { data } = await api.post(`database/deliveries__c/aggregate?strict=true`, payload);
  if (!Array.isArray(data)) {
    return [];
  } else {
    return data;
  }
}

export async function updateEntregas(data?: any) {
  try {
    const response = await api.put('/database/deliveries__c?strict=true', data);
    if (!response.data) {
      throw new Error('Erro ao salvar entregas');
    } else {
      return response.data;
    }
  } catch (error) {
    throw error;
  }
}

export async function createHistory(idPedido?: string, name?: string) {
  try {
    const payload = {
      "idPedido": idPedido,      
      "obs": "Informado por " + name + " pelo site Conta Comigo que o pedido foi entregue.",
      "status": "ENT",
      "tipo": "PARTICIPANTE",
      "data": {"$date": new Date().getTime()},
      "responsavel": {
        "name": name
      }
    } 

    const { data } = await api.post('database/history_delivery__c', payload);

    if (!Array.isArray(data)) {
      return [];
    } else {
      return data;
    }
  } catch (e) {
    throw e;
  }
}